import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import feed1 from '../assets/feedback/feed1.webp';
import feed2 from '../assets/feedback/feed2.webp';
import feed3 from '../assets/feedback/feed3.webp';
import feed4 from '../assets/feedback/feed4.webp';
import feeds1 from '../assets/feedsmall/feeds1.webp';
import feeds2 from '../assets/feedsmall/feeds2.webp';
import feeds3 from '../assets/feedsmall/feeds3.webp';
import feeds4 from '../assets/feedsmall/feeds4.webp';
import feeds5 from '../assets/feedsmall/feeds5.webp';
import feeds6 from '../assets/feedsmall/feeds6.webp';
import feeds7 from '../assets/feedsmall/feeds7.webp';
import feeds8 from '../assets/feedsmall/feeds8.webp';
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from 'react-icons/bs'; // Importing icons

import { useTranslation } from 'react-i18next';

const desktopImages = [feed1, feed2, feed3, feed4];
const mobileImages = [
  feeds1, feeds2, feeds3, feeds4, feeds5, feeds6, feeds7, feeds8,
];

export default function Feedback() {
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Detect if the screen width is less than or equal to 768px (mobile)
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleImageClick = () => {
    setIsPlaying(!isPlaying);
  };

  const imagesToShow = isMobile ? mobileImages : desktopImages;

  return (
    <div>
      <div id="feedback" className="p-4">
        <div className="m-10 text-center mt-24 mb-[4rem]">
          <p className="text-lg font-medium text-gray-600 font-pj sm:text-sm sm:mt-6 sm:mb-2 md:text-base md:mt-7 md:mb-3 xl:text-2xl max-[480px]:text-sm">
            {t('feed1')}
          </p>
          <h2 className="text-2xl font-bold text-gray-900 font-pj sm:text-xl md:text-2xl xl:text-3xl max-[480px]:text-lg">
            {t('feed2')}
          </h2>
        </div>

        <div id="home" className="relative w-full mx-auto overflow-hidden">
          <Carousel
            autoPlay={isPlaying}
            interval={5000}
            infiniteLoop
            showThumbs={false}
            showStatus={false}
            dynamicHeight={false}
            emulateTouch
            stopOnClick={true}
            renderIndicator={(clickHandler, isSelected, index, label) => {
              if (!isMobile) {
                const className = isSelected ? 'bg-black' : 'bg-gray-400';
                return (
                  <li
                    className={`inline-block w-3 h-3 mx-1 rounded-full cursor-pointer ${className}`}
                    aria-label={`Go to slide ${label} ${index + 1}`}
                    title={`Go to slide ${label} ${index + 1}`}
                    onClick={clickHandler}
                    onKeyDown={clickHandler}
                    value={index}
                    role="button"
                    tabIndex={0}
                  />
                );
              }
              return null; // Return nothing in mobile view
            }}
            renderArrowPrev={(clickHandler, hasPrev) =>
              hasPrev && (
                <button
                  type="button"
                  onClick={clickHandler}
                  className="absolute z-10 text-3xl text-gray-400 left-4 md:left-8"
                  style={{ top: '50%', transform: 'translateY(-50%)' }}
                >
                  <BsArrowLeftCircleFill />
                </button>
              )
            }
            renderArrowNext={(clickHandler, hasNext) =>
              hasNext && (
                <button
                  type="button"
                  onClick={clickHandler}
                  className="absolute z-10 text-3xl text-gray-400 right-4 md:right-8"
                  style={{ top: '50%', transform: 'translateY(-50%)' }}
                >
                  <BsArrowRightCircleFill />
                </button>
              )
            }
          >
            {imagesToShow.map((src, index) => (
              <div key={index} className="relative flex items-center justify-center">
                <img
                  src={src}
                  alt={`Slide ${index + 1}`}
                  className="carousel-image rounded-2xl"
                  onClick={handleImageClick}
                  style={{
                    objectFit: 'cover', // Ensures the image covers the container properly
                    objectPosition: 'center',
                    margin: '0 5px',
                    borderRadius: '20px',
                  }}
                />
                {!isPlaying && (
                  <div className="absolute inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50 rounded-2xl">
                    <span className="text-white">Paused</span>
                  </div>
                )}
              </div>
            ))}
          </Carousel>
          <style jsx>{`
            .carousel-image {
              width: calc(100% - 10px); /* Adjusted margin for better fit */
              height: 500px;
              border-radius: 20px;
            }

            @media (max-width: 768px) {
              .carousel-image {
                height: auto;
              }
            }

            @media (max-width: 480px) {
              .carousel-image {
                width: 100%; /* Full width in smaller mobile screens */
                height: 350px; /* Adjust height for smaller screens */
                object-fit: cover; /* Ensures no part of the image is cut off */
              }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
}
